import React, { useContext } from "react";
import { CurrencyContext } from "../../context/CurrencyContext";

const CurrencySelector = () => {
  const { currency, setCurrency, loading, apiFailed } =
    useContext(CurrencyContext);

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value); // Dynamically handle currency change
  };

  const showCurrencySelector = !loading && !apiFailed;

  return (
    <div>
      {showCurrencySelector ? (
        <>
          <select
            id='currency'
            value={currency}
            onChange={handleCurrencyChange}
            className='currency-dropdown'
          >
            <option value='AUD'>AUD</option>
            <option value='NZD'>NZD</option>
            <option value='GBP'>GBP</option>
            <option value='EUR'>EUR</option>
            <option value='USD'>USD</option>
            <option value='CAD'>CAD</option>
          </select>
        </>
      ) : (
        // If no rates are available or it's still loading, just display AUD
        <div className='base-currency'>
          <label htmlFor='currency'>AUD</label>
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
